const loadedAvatarSources = new Set<string>()
const avatarLoadPromises = new Map<string, Promise<void>>()

export function isAvatarImageLoaded(src: string): boolean {
  return loadedAvatarSources.has(src)
}

export function preloadAvatarImage(src: string): Promise<void> {
  if (loadedAvatarSources.has(src)) {
    return Promise.resolve()
  }

  const existingPromise = avatarLoadPromises.get(src)
  if (existingPromise) {
    return existingPromise
  }

  const preloadPromise = new Promise<void>((resolve, reject) => {
    const image = new Image()

    image.onload = () => {
      loadedAvatarSources.add(src)
      avatarLoadPromises.delete(src)
      resolve()
    }

    image.onerror = () => {
      avatarLoadPromises.delete(src)
      reject(new Error('Failed to preload avatar image'))
    }

    image.src = src
  })

  avatarLoadPromises.set(src, preloadPromise)
  return preloadPromise
}
